import React from "react";

export default () => (
    <React.Fragment>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(
                    {
                        "@context": "http://schema.org",
                        "@type": "HotelRoom",
                        "name": "Executive Room",
                        "url": "https://www.hoteltwintowers.com/hotel-room-in-shimla/executive-room",
                        "image": "https://www.hoteltwintowers.com/images/exec-banner.png",
                        "description": "These 80-square-meter rooms provide highly customized attention and maximum convenience. These best executive rooms in Kufri are fully soundproof and include contemporary furnishings. Guests may enjoy modern conveniences including a keyless entry system, free Wi-Fi, a smart TV, a tea and coffee maker, and more.",
                        "containedInPlace": {
                            "@type": "Place",
                            "name": "The Twin Towers Hotel",
                            "url": "https://hoteltwintowers.com/",
                            "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "NH 05, New kufri, Galu, Hills,",
                                "addressLocality": "Shimla",
                                "addressRegion": "Indian Himalayan Region",
                                "postalCode": "171209",
                                "addressCountry": "India"
                            }
                        },
                        "bed": {
                            "@type": "BedDetails",
                            "numberOfBeds": 2
                        },
                        "occupancy": {
                            "@type": "QuantitativeValue",
                            "maxValue": "2"
                        },
                        "amenityFeature": [
                            {
                                "@type": "LocationFeatureSpecification", "value": "True", "name": "City Views"
                            },
                            { "@type": "LocationFeatureSpecification", "value": "True", "name": "Balcony" },
                            { "@type": "LocationFeatureSpecification", "value": "True", "name": "King Size Bed" }
                        ]
                    }                       
                )
            }}
        />
    </React.Fragment>
);
